export const SalesVolumeTypes = {
  IGetSalesVolumeService: Symbol("IGetSalesVolumeService"),
};
